import Container from '@mui/material/Container';

export default Container;